import { SwiperSlide } from "swiper/react";
import Center from "../../components/core/Center/Center";
import Image from "../../components/core/Image/Image";
import SliderComponent from "../../components/core/Slider/Slider";
import { translate } from "../../localization";
import styles from "./Slider.module.scss";

export interface Image {
  src: string;
  title: string;
}

interface SliderProps {
  images: Image[];
}

const Slider = ({ images }: SliderProps) => {
  const i18n = translate();

  if (!images.length) {
    return null;
  }

  return (
    <Center className={styles.slider}>
      <SliderComponent items={1} navigation>
        {images.map((image, index) => (
          <SwiperSlide key={index} className={styles.slide}>
            <Image className={styles.image} src={image.src} />
            <div className={styles.text}>
              <div className={styles.field}>
                <div className={styles.label}>{i18n.home.slider.title}: </div>
                <div>{image.title}</div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </SliderComponent>
    </Center>
  );
};

export default Slider;
